import axios from "axios";


const API_URL = ""

const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json'
    },
    withCredentials: true
})

// перехоплювач для додавання shared.options.log.id(wslog id) в data всіх запитів
api.interceptors.request.use(config => {
    const wsLogId = shared.options.log.id

    if (config.data instanceof FormData) {
        config.data.append('s', wsLogId)
    } else {
        config.data = {
            s: wsLogId,
            ...config.data
        }
    }

    return config;
})

export default api

